import { defineComponent as _defineComponent } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'ProfilePageWallCardSkeleton',
  props: {
    cardWidth: { default: 190 }
  },
  setup(__props: any) {



return { __sfc: true, }
}

})